import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectInteractionBar } from "../../utils/injectInteractionBar.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { getEasing } from "../../utils/getEasing.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-4fszem" }) `
  --iconsize: 24px;
  --padding-inline: calc(
    var(${(props) => props.theme.responsive.spacing.s}) + var(--iconsize)
  );

  ${injectSpacing('margin')}
`;
export const StyledInnerContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledInnerContainer", componentId: "auir-611444a-1ifxoay" }) `
  display: grid;
  grid-template-columns: [search-icon] 24px [input] 1fr [clear-icon] 24px [end];
  align-items: center;

  ${(props) => injectInteractionBar(props)}

  &::after {
    grid-column: search-icon / end;
  }
`;
const injectFieldLayout = css `
  display: block;
  grid-row: 1;
  grid-column: search-icon / end;

  margin: 0;
  padding: 0;
  padding-inline-start: var(--padding-inline);
  padding-inline-end: var(--padding-inline);
  padding-block-start: var(${(props) => props.theme.responsive.spacing.xxs});
  padding-block-end: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledLabel = styled.label.withConfig({ displayName: "auir-611444a-StyledLabel", componentId: "auir-611444a-56098t" }) `
  ${injectFieldLayout}

  ${(props) => injectTypography(props, 'copy1')}

  color: var(${(props) => props.theme.colors.interaction.label.default});
  &:hover {
    color: var(
      ${(props) => props.disabled
    ? props.theme.colors.interaction.label.disabled
    : props.theme.colors.interaction.label.hover}
    );
  }

  opacity: 1;

  transition-timing-function: var(${getEasing});
  transition-duration: 0.25s;
  transition-property: color, opacity;

  ${injectOSXFontSmoothing(true)}

  *:focus-within > & {
    opacity: 0;
  }

  ${(props) => props.disabled &&
    css `
      color: var(${(props) => props.theme.colors.interaction.label.disabled});

      cursor: not-allowed;
    `}

  ${(props) => !props.empty &&
    css `
      opacity: 0;

      pointer-events: none;
    `}
`;
export const StyledInput = styled.input.withConfig({ displayName: "auir-611444a-StyledInput", componentId: "auir-611444a-so4atm" }) `
  all: revert;

  color: var(${(props) => props.theme.colors.interaction.secondary.filled});

  ${injectFieldLayout}

  ${(props) => injectTypography(props, 'copy1')}

  background-color: transparent;
  border: 0;

  transition: color 0.25s var(${getEasing});

  appearance: none;

  ${injectOSXFontSmoothing(true)}

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  &:disabled {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});

    cursor: not-allowed;
  }

  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    display: none;
  }
`;
export const StyledIcon = styled.svg.withConfig({ displayName: "auir-611444a-StyledIcon", componentId: "auir-611444a-f0kvgd" }) `
  all: revert;

  display: block;
  width: var(--iconsize);
  height: var(--iconsize);

  color: var(
    ${(props) => props.disabled
    ? props.theme.colors.interaction.label.disabled
    : props.theme.colors.interaction.label.default}
  );

  pointer-events: none;
`;
export const StyledClearIcon = styled.svg.withConfig({ displayName: "auir-611444a-StyledClearIcon", componentId: "auir-611444a-vrdn6z" }) `
  all: revert;

  display: block;
  width: var(--iconsize);
  height: var(--iconsize);

  pointer-events: none;
`;
export const StyledSearchIconContainer = styled.span.withConfig({ displayName: "auir-611444a-StyledSearchIconContainer", componentId: "auir-611444a-6e79gc" }) `
  grid-row: 1;
  grid-column: search-icon;
  padding-block-start: var(${(props) => props.theme.responsive.spacing.xxs});
  padding-block-end: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledClearButton = styled.button.withConfig({ displayName: "auir-611444a-StyledClearButton", componentId: "auir-611444a-1uu4lb" }) `
  all: revert;

  display: block;

  grid-row: 1;
  grid-column: clear-icon;

  width: var(--iconsize);
  height: var(--iconsize);

  padding: 0;
  margin-block-start: var(${(props) => props.theme.responsive.spacing.xxs});
  margin-block-end: var(${(props) => props.theme.responsive.spacing.xs});

  color: var(
    ${(props) => props.disabled
    ? props.theme.colors.interaction.secondary.disabled
    : props.theme.colors.interaction.secondary.default}
  );

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  background: transparent;
  border: none;

  cursor: pointer;
`;
//# sourceMappingURL=Search.styles.mjs.mjs.map